export const NAVIGATION_PUSH = 'NAVIGATION_PUSH'
export const NAVIGATION_PUSH_SUCCESS = 'NAVIGATION_PUSH_SUCCESS'
export const NAVIGATION_PUSH_FAILED = 'NAVIGATION_PUSH_FAILED'

export const NAVIGATION_TOGGLE = 'NAVIGATION_TOGGLE'
